import React from "react";
import { Route, Switch } from "react-router-dom";
import AdminLawFirmsPage from "../../components/admin/AdminLawFirmsPage";
import AdminOrganizationDetailPage from "../../components/admin/AdminOrganizationDetailPage";

export const AdminRoutes = () => {
  return (
    <Switch>
      <Route exact path={`/`} component={() => <AdminLawFirmsPage />} />
      <Route
        path={`/admin/organizations/:orgId`}
        component={AdminOrganizationDetailPage}
      />
    </Switch>
  );
};
